import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css' //
// main.js
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: '#686059',
    secondary: '#b7ada5',
    accent: '#906d4f',
    error: '#b71c1c'
  }
})
